var _circle, _path, _ellipse, _ellipse2, _circle2, _circle3, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCatHorror(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 38,
    fill: "#e8ecf5",
    stroke: "#b0bcd8",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 58 L24 36 Q24 18 40 18 Q56 18 56 36 L56 58 Q52 54 48 58 Q44 54 40 58 Q36 54 32 58 Q28 54 24 58Z",
    fill: "#dde4f0",
    stroke: "#8898c0",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33,
    cy: 38,
    rx: 4,
    ry: 5,
    fill: "#3a4a6a"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47,
    cy: 38,
    rx: 4,
    ry: 5,
    fill: "#3a4a6a"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 36.5,
    r: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 36.5,
    r: 1.5,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 48 Q37 52 40 48 Q43 52 47 48",
    stroke: "#3a4a6a",
    strokeWidth: 2,
    strokeLinecap: "round",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 24 L19.5 21 L21 24 L18.5 22.5 L21.5 22.5Z",
    fill: "#8898c0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 28 L61 25.5 L62 28 L60 26.5 L62.5 26.5Z",
    fill: "#8898c0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62 52 L63 50 L64 52 L62 50.5 L64.5 50.5Z",
    fill: "#8898c0",
    opacity: 0.7
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatHorror);
export default __webpack_public_path__ + "static/media/cat-horror.d8e4bbb2347a59c870b77fb809d560d8.svg";
export { ForwardRef as ReactComponent };